import { useEffect, useState } from 'react';
import { suplidoresService } from '../services/api';
import '../styles/Clientes.css';

const Suplidores = () => {
  const [suplidores, setSuplidores] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedSuplidor, setSelectedSuplidor] = useState(null);
  const [formData, setFormData] = useState({
    nombre: '',
    rnc_cedula: '',
    telefono: '',
    email: '',
    direccion: '',
    contacto_principal: '',
    telefono_contacto: '',
    notas: '',
    activo: true
  });
  const [editingId, setEditingId] = useState(null);

  useEffect(() => {
    cargarSuplidores();
  }, []);

  const cargarSuplidores = async () => {
    try {
      setLoading(true);
      const response = await suplidoresService.getSuplidores();
      setSuplidores(response.data.suplidores || []);
    } catch (error) {
      console.error('Error al cargar suplidores:', error);
      setError('Error al cargar suplidores');
    } finally {
      setLoading(false);
    }
  };

  const handleOpenModal = (suplidor = null) => {
    if (suplidor) {
      setEditingId(suplidor.id);
      setFormData({
        nombre: suplidor.nombre || '',
        rnc_cedula: suplidor.rnc_cedula || '',
        telefono: suplidor.telefono || '',
        email: suplidor.email || '',
        direccion: suplidor.direccion || '',
        contacto_principal: suplidor.contacto_principal || '',
        telefono_contacto: suplidor.telefono_contacto || '',
        notas: suplidor.notas || '',
        activo: suplidor.activo !== undefined ? suplidor.activo : true
      });
    } else {
      setEditingId(null);
      setFormData({
        nombre: '',
        rnc_cedula: '',
        telefono: '',
        email: '',
        direccion: '',
        contacto_principal: '',
        telefono_contacto: '',
        notas: '',
        activo: true
      });
    }
    setShowModal(true);
    setError('');
    setSuccess('');
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditingId(null);
    setFormData({
      nombre: '',
      rnc_cedula: '',
      telefono: '',
      email: '',
      direccion: '',
      contacto_principal: '',
      telefono_contacto: '',
      notas: '',
      activo: true
    });
  };

  const handleViewDetails = (suplidor) => {
    setSelectedSuplidor(suplidor);
    setShowDetailModal(true);
  };

  const handleCloseDetailModal = () => {
    setShowDetailModal(false);
    setSelectedSuplidor(null);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      setLoading(true);

      if (editingId) {
        await suplidoresService.updateSuplidor(editingId, formData);
        setSuccess('Suplidor actualizado correctamente');
      } else {
        await suplidoresService.createSuplidor(formData);
        setSuccess('Suplidor creado correctamente');
      }

      handleCloseModal();
      await cargarSuplidores();
    } catch (error) {
      console.error('Error al guardar suplidor:', error);
      setError(error.response?.data?.message || error.response?.data?.error || 'Error al guardar el suplidor');
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm('¿Estás seguro de que deseas eliminar este suplidor?')) {
      return;
    }

    try {
      setLoading(true);
      await suplidoresService.deleteSuplidor(id);
      setSuccess('Suplidor eliminado correctamente');
      await cargarSuplidores();
    } catch (error) {
      console.error('Error al eliminar suplidor:', error);
      setError(error.response?.data?.message || error.response?.data?.error || 'Error al eliminar el suplidor');
    } finally {
      setLoading(false);
    }
  };

  if (loading) return <div className="loading">Cargando suplidores...</div>;

  return (
    <div className="clientes-page">
      <div className="clientes-header">
        <h1>🚚 Suplidores</h1>
        <button className="btn btn-primary" onClick={() => handleOpenModal()}>
          + Nuevo Suplidor
        </button>
      </div>

      {error && <div className="banner error">{error}</div>}
      {success && <div className="banner success">{success}</div>}

      {/* Tabla de Suplidores */}
      <div className="card">
        <div className="card-title">
          Suplidores ({suplidores.length})
        </div>

        {suplidores.length === 0 ? (
          <p style={{padding: '2rem', textAlign: 'center', color: '#666'}}>
            No hay suplidores registrados
          </p>
        ) : (
          <div style={{overflowX: 'auto'}}>
            <table className="table">
              <thead>
                <tr>
                  <th>ID</th>
                  <th>Nombre</th>
                  <th>RNC/Cédula</th>
                  <th>Teléfono</th>
                  <th>Email</th>
                  <th>Contacto</th>
                  <th>Estado</th>
                  <th>Acciones</th>
                </tr>
              </thead>
              <tbody>
                {suplidores.map((suplidor) => (
                  <tr key={suplidor.id}>
                    <td>{suplidor.id}</td>
                    <td style={{fontWeight: 'bold'}}>{suplidor.nombre}</td>
                    <td>{suplidor.rnc_cedula || '-'}</td>
                    <td>{suplidor.telefono || '-'}</td>
                    <td>{suplidor.email || '-'}</td>
                    <td>{suplidor.contacto_principal || '-'}</td>
                    <td>
                      <span style={{
                        backgroundColor: suplidor.activo ? '#27ae60' : '#95a5a6',
                        color: '#fff',
                        padding: '4px 8px',
                        borderRadius: '4px',
                        fontSize: '0.85rem'
                      }}>
                        {suplidor.activo ? 'ACTIVO' : 'INACTIVO'}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn-icon"
                        title="Ver detalles"
                        onClick={() => handleViewDetails(suplidor)}
                      >
                        👁️
                      </button>
                      <button
                        className="btn-icon"
                        title="Editar"
                        onClick={() => handleOpenModal(suplidor)}
                        style={{marginLeft: '0.5rem'}}
                      >
                        ✏️
                      </button>
                      <button
                        className="btn-icon"
                        title="Eliminar"
                        onClick={() => handleDelete(suplidor.id)}
                        style={{marginLeft: '0.5rem'}}
                      >
                        🗑️
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>

      {/* Modal para crear/editar suplidor */}
      {showModal && (
        <div className="modal-overlay" onClick={handleCloseModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>{editingId ? 'Editar Suplidor' : 'Nuevo Suplidor'}</h2>
              <button className="modal-close" onClick={handleCloseModal}>×</button>
            </div>

            <form onSubmit={handleSubmit}>
              <div className="form-grid">
                <div className="form-group">
                  <label>Nombre *</label>
                  <input
                    type="text"
                    name="nombre"
                    value={formData.nombre}
                    onChange={handleInputChange}
                    placeholder="Nombre del suplidor"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>RNC/Cédula</label>
                  <input
                    type="text"
                    name="rnc_cedula"
                    value={formData.rnc_cedula}
                    onChange={handleInputChange}
                    placeholder="RNC o Cédula"
                  />
                </div>

                <div className="form-group">
                  <label>Teléfono</label>
                  <input
                    type="tel"
                    name="telefono"
                    value={formData.telefono}
                    onChange={handleInputChange}
                    placeholder="Ej: 809-555-5555"
                  />
                </div>

                <div className="form-group">
                  <label>Email</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    placeholder="correo@ejemplo.com"
                  />
                </div>

                <div className="form-group">
                  <label>Contacto Principal</label>
                  <input
                    type="text"
                    name="contacto_principal"
                    value={formData.contacto_principal}
                    onChange={handleInputChange}
                    placeholder="Nombre del contacto"
                  />
                </div>

                <div className="form-group">
                  <label>Teléfono del Contacto</label>
                  <input
                    type="tel"
                    name="telefono_contacto"
                    value={formData.telefono_contacto}
                    onChange={handleInputChange}
                    placeholder="Ej: 809-555-5555"
                  />
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label>Dirección</label>
                  <input
                    type="text"
                    name="direccion"
                    value={formData.direccion}
                    onChange={handleInputChange}
                    placeholder="Dirección completa"
                  />
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label>Notas</label>
                  <textarea
                    name="notas"
                    value={formData.notas}
                    onChange={handleInputChange}
                    placeholder="Notas adicionales"
                    rows="3"
                  />
                </div>

                <div className="form-group">
                  <label>
                    <input
                      type="checkbox"
                      name="activo"
                      checked={formData.activo}
                      onChange={handleInputChange}
                      style={{marginRight: '0.5rem'}}
                    />
                    Activo
                  </label>
                </div>
              </div>

              <div className="modal-footer">
                <button type="button" className="btn btn-secondary" onClick={handleCloseModal}>
                  Cancelar
                </button>
                <button type="submit" className="btn btn-primary" disabled={loading}>
                  {loading ? 'Guardando...' : (editingId ? 'Actualizar' : 'Crear')}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* Modal de detalles */}
      {showDetailModal && selectedSuplidor && (
        <div className="modal-overlay" onClick={handleCloseDetailModal}>
          <div className="modal-content" onClick={(e) => e.stopPropagation()}>
            <div className="modal-header">
              <h2>Detalles del Suplidor</h2>
              <button className="modal-close" onClick={handleCloseDetailModal}>×</button>
            </div>

            <div style={{padding: '1.5rem'}}>
              <div className="form-grid">
                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>Nombre:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.nombre}</p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>RNC/Cédula:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.rnc_cedula || 'N/A'}</p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>Teléfono:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.telefono || 'N/A'}</p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>Email:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.email || 'N/A'}</p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>Contacto Principal:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.contacto_principal || 'N/A'}</p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>Teléfono del Contacto:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.telefono_contacto || 'N/A'}</p>
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label style={{fontWeight: 'bold', color: '#666'}}>Dirección:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.direccion || 'N/A'}</p>
                </div>

                <div className="form-group" style={{gridColumn: '1 / -1'}}>
                  <label style={{fontWeight: 'bold', color: '#666'}}>Notas:</label>
                  <p style={{margin: '0.5rem 0', fontSize: '1rem'}}>{selectedSuplidor.notas || 'N/A'}</p>
                </div>

                <div className="form-group">
                  <label style={{fontWeight: 'bold', color: '#666'}}>Estado:</label>
                  <p style={{margin: '0.5rem 0'}}>
                    <span style={{
                      backgroundColor: selectedSuplidor.activo ? '#27ae60' : '#95a5a6',
                      color: '#fff',
                      padding: '4px 12px',
                      borderRadius: '4px',
                      fontSize: '0.9rem'
                    }}>
                      {selectedSuplidor.activo ? 'ACTIVO' : 'INACTIVO'}
                    </span>
                  </p>
                </div>
              </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={handleCloseDetailModal}>
                Cerrar
              </button>
              <button
                className="btn btn-primary"
                onClick={() => {
                  handleCloseDetailModal();
                  handleOpenModal(selectedSuplidor);
                }}
              >
                Editar
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Suplidores;
